import { createFileRoute } from "@tanstack/react-router";
import { ProjectDetails } from "~/pages/project-details";

export const Route = createFileRoute("/_app/projects/$projectId/")({
  component: ProjectDetails,
});
